import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QRCode from "qrcode";
import { bindingGoogleCode, generateGoogleCode } from "@/api/google";
export default {
  name: "ForceGoogleBinding",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loginData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var validateCode = function validateCode(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入验证码"));
      }
      if (!/^\d{6}$/.test(value)) {
        return callback(new Error("请输入6位数字验证码"));
      }
      callback();
    };
    return {
      currentStep: 1,
      qrurl: "",
      isBinding: false,
      bindData: {
        code: "",
        secret: ""
      },
      rules: {
        code: [{
          validator: validateCode,
          trigger: "blur"
        }]
      }
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.initBinding();
      }
    }
  },
  methods: {
    initBinding: function initBinding() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.currentStep = 1;
              _this.bindData.code = "";
              _this.bindData.secret = "";
              _this.qrurl = "";
              _context.next = 1;
              return _this.getGoogleQrCode();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getGoogleQrCode: function getGoogleQrCode() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return generateGoogleCode({
                ID: _this2.userInfo.ID
              });
            case 1:
              res = _context2.sent;
              if (!(res.code === 0)) {
                _context2.next = 3;
                break;
              }
              _this2.bindData.secret = res.data.secret;
              _context2.next = 2;
              return _this2.generateQRCode(res.data.url);
            case 2:
              _this2.qrurl = _context2.sent;
              _context2.next = 4;
              break;
            case 3:
              _this2.$message.error(res.msg || "生成二维码失败");
              // 如果失败，重新尝试
              setTimeout(function () {
                _this2.getGoogleQrCode();
              }, 2000);
            case 4:
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t = _context2["catch"](0);
              _this2.$message.error("生成二维码失败，请稍后重试");
              console.error("生成Google二维码失败:", _t);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }))();
    },
    generateQRCode: function generateQRCode(text) {
      return new Promise(function (resolve, reject) {
        QRCode.toDataURL(text, function (err, url) {
          if (err) reject(err);
          resolve(url);
        });
      });
    },
    nextStep: function nextStep() {
      var _this3 = this;
      if (this.qrurl) {
        this.currentStep = 2;
        this.$nextTick(function () {
          _this3.$refs.bindForm && _this3.$refs.bindForm.clearValidate();
        });
      }
    },
    prevStep: function prevStep() {
      this.currentStep = 1;
      this.bindData.code = "";
    },
    confirmBinding: function confirmBinding() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this4.$refs.bindForm) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return");
            case 1:
              _this4.$refs.bindForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                  var res, updatedUserInfo;
                  return regeneratorRuntime.wrap(function (_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (valid) {
                          _context3.next = 1;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 1:
                        _this4.isBinding = true;
                        _context3.prev = 2;
                        _context3.next = 3;
                        return bindingGoogleCode(_objectSpread({
                          ID: String(_this4.userInfo.ID)
                        }, _this4.bindData));
                      case 3:
                        res = _context3.sent;
                        if (!(res.code === 0)) {
                          _context3.next = 5;
                          break;
                        }
                        _this4.$message.success("Google身份验证器绑定成功！");

                        // 更新用户信息
                        updatedUserInfo = _objectSpread(_objectSpread({}, _this4.userInfo), {}, {
                          totpSecret: _this4.bindData.secret
                        }); // 完成登录流程 - 调用store中的完整登录方法
                        if (!_this4.loginData.token) {
                          _context3.next = 4;
                          break;
                        }
                        _context3.next = 4;
                        return _this4.$store.dispatch("user/CompleteLoginAfterBinding", {
                          userInfo: updatedUserInfo,
                          token: _this4.loginData.token,
                          merchantGrade: _this4.loginData.merchantGrade,
                          merchantId: _this4.loginData.merchantId
                        });
                      case 4:
                        // 通知父组件绑定完成
                        _this4.$emit("binding-success");
                        _context3.next = 6;
                        break;
                      case 5:
                        _this4.$message.error(res.msg || "绑定失败，请检查验证码");
                      case 6:
                        _context3.prev = 6;
                        _this4.isBinding = false;
                        return _context3.finish(6);
                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[2,, 6, 7]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handleClose: function handleClose() {
      // 阻止关闭，因为这是强制绑定
      this.$message.warning("为了账户安全，必须完成Google身份验证器绑定");
      return false;
    }
  }
};